var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.milestonesList
    ? _c(
        "div",
        {
          staticClass: "d-flex flex-column p-4 milestone-wrapper",
          attrs: { id: "milestones-list-wrapper" }
        },
        [
          _c("h2", { staticClass: "my-2" }, [
            _vm._v("\n    Rank Milestones\n  ")
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "mb-4" }, [
            _vm._v(
              "Complete Missions & Claim Your Points to Get These Cool Badges!"
            )
          ]),
          _vm._v(" "),
          _vm._l(_vm.milestonesList, function(milestone, index) {
            return _c(
              "div",
              {
                key: milestone.name,
                staticClass: "milestone-item",
                on: {
                  click: function($event) {
                    return _vm.expandMilestone(milestone, index)
                  }
                }
              },
              [
                _c("div", { staticClass: "d-flex align-items-center w-100" }, [
                  _c("div", { class: { "image-wrapper": !milestone.image } }, [
                    milestone.image
                      ? _c("img", {
                          staticClass: "mr-4 rounded",
                          attrs: {
                            src: milestone.image,
                            width: "120",
                            height: "120"
                          }
                        })
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "d-flex flex-column flex-grow-1" }, [
                    _c("span", { staticClass: "milestone-name" }, [
                      _vm._v(_vm._s(milestone.name))
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(milestone.earnMessage))])
                  ]),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "arrow",
                    class: { expand: _vm.selectedIndex === index },
                    attrs: {
                      src: require("@/images/right-chevron.png"),
                      alt: "arrow",
                      width: "20",
                      height: "20"
                    }
                  })
                ]),
                _vm._v(" "),
                _vm.selectedIndex === index
                  ? _c(
                      "div",
                      { staticClass: "d-flex w-100 flex-column px-3" },
                      [
                        _c("h5", { staticClass: "my-3" }, [
                          _vm._v("\n        Unlockables:\n      ")
                        ]),
                        _vm._v(" "),
                        _vm._l(milestone.unlockables, function(unlockable) {
                          return _c("div", { key: unlockable.name }, [
                            _c(
                              "div",
                              {
                                class:
                                  !unlockable.listingImage && "image-wrapper"
                              },
                              [
                                unlockable.listingImage
                                  ? _c("img", {
                                      staticClass: "mr-4 rounded",
                                      attrs: {
                                        src: unlockable.listingImage,
                                        width: "60",
                                        height: "60"
                                      }
                                    })
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex align-items-center mr-4 my-4"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "point-icon",
                                    attrs: { id: "point-icon" }
                                  },
                                  [_vm._v("\n            P\n          ")]
                                ),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(milestone.experienceRequired))
                                ])
                              ]
                            )
                          ])
                        })
                      ],
                      2
                    )
                  : _vm._e()
              ]
            )
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "d-flex flex-column flex-grow-1 justify-content-center align-items-center mt-4"
            },
            [
              _c(
                "VsButton",
                {
                  staticClass: "go-to-btn",
                  on: {
                    click: function($event) {
                      return _vm.goTo("missions")
                    }
                  }
                },
                [_vm._v("\n      Complete Mission to Unlock!\n    ")]
              )
            ],
            1
          )
        ],
        2
      )
    : _c("div", { staticClass: "p-6 text-center" }, [
        _vm._v("\n  Loading...\n")
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }